import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Validators, FormControl, FormBuilder, FormGroup } from '@angular/forms';

import { SessionService } from '../../services/session.service';
import { AdminService } from '../../services/admin.service';
import { RegionService } from '../../services/region.service';

interface FormFormControlObject {
  [key: string]: FormControl;
}

@Component({
  selector: 'admin-settings-page',
  templateUrl: 'admin-settings.html'
})
export class AdminSettingsPage {

  private settingsFormObject: FormGroup;
  private settingsFormControlObject: FormFormControlObject;

  isValid: boolean;
  showKeypad: boolean;
  formIsReady: boolean;
  showContent: boolean;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    public regionService: RegionService,
    public sessionService: SessionService,
    private adminService: AdminService
  ) { }


  private updateForm(): void {
    setTimeout(() => {
      this.adminService.setSettings();
      const valid: boolean = this.settingsFormObject.valid;
      // console.log(valid);
    }, 100);
  }

  private generateFormControlObj(): FormFormControlObject {

    const settingsFormControlObject: FormFormControlObject = {};

    function buildFormControl(field: any): void {
      const validators: any[] = [];
      if (field.required) {
        validators.push(<any>Validators.required);
      }
      // if (field.maxLength) {
      //   validators.push(<any>Validators.maxLength(field.maxLength));
      // }
      settingsFormControlObject[field.name] = new FormControl(
        field.model,
        validators
      );
    }

    this.adminService.fields.forEach((field: any) => {
      buildFormControl(field);
      settingsFormControlObject[field.name].valueChanges.subscribe(
        (value: number) => {

          if (field.type === 'toggle') {
            const optionValue: any = field['options'][value ? 1 : 0].value;

            if (field.name === 'fullScreen') {
              console.log(value, optionValue);

              if (value !== field['selected']) {
                value ? macs.toggleFullScreenMode(optionValue, () => { }, () => { }) : macs.exitFullScreenMode(() => { }, () => { });
              }

              field['selected'] = value;
            }

            field['selected'] = value;
            field.model = field['options'][value ? 1 : 0].value;

          } else if (field.type === 'text' || field.type === 'tel') {
            field.model = value;
          }

          this.adminService.station[field.name] = field.model;
          this.updateForm();
        }
      );
    });

    return settingsFormControlObject;
  }

  private buildForm(): void {
    this.settingsFormControlObject = this.generateFormControlObj();
    this.settingsFormObject = this.formBuilder.group(this.settingsFormControlObject);

    setTimeout(() => {
      this.formIsReady = true;
    }, 300);
  }

  onFormChange(e: any): void {
    if (e) {
      // console.log(e);
      this.isValid = this.adminService.isValidPin();
    }
  }

  submit(formValues: any, valid: boolean): void {
    // const newFormValues = { ...formValues };
    // console.log(newFormValues, valid);
  }

  close(): void {
    this.sessionService.init().subscribe(() => this.router.navigate(['home']));
  }

  ngAfterViewInit(): void {
    this.buildForm();
  }

}



// WEBPACK FOOTER //
// ./src/pages/admin-settings/admin-settings.ts